/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, March 30th 2024, 3:02:36 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import { TMediaAssetMetaData } from "lib/schemas";
import { StyledOSDialog, OSActionButton, FormSubmitBubblingStopper, ImagePreviewContainer } from "ui-widgets";
import { OSFormInputProps } from "ui-widgets/forms";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { MediaLibraryComponent } from "./MediaLibraryComponent";

export const FromMediaLibraryFormInput = <T,>(props: OSFormInputProps<T>) => {
  const { setValue, watch } = useOSFormContext<T>();
  const onChange = (value: any) => {
    setValue(props.schema_field_key as unknown as any, value, { shouldDirty: true });
  };
  const watchedValue = watch(props.schema_field_key as any) as TMediaAssetMetaData;
  return (
    <FormSubmitBubblingStopper>
      <StyledOSDialog
        maxWidth="xl"
        popUpTitle={`Choose ${props.label || ""} from library`}
        popUpIcon={<PhotoLibraryIcon color="primary" />}
        renderOpenButton={({ handleOpen }) => (
          <>
            <OSActionButton onClick={handleOpen}>Choose {props.label || ""} from library</OSActionButton>
            <ImagePreviewContainer
              imageSrc={(watchedValue?.media_item_url || watchedValue) as string}
              imageTitle={props.label}
              handleDeletePreview={() => onChange(null)}
            />
          </>
        )}
        renderContentWithClose={({ handleClose }) => {
          const onChooseAsset = (metaData: TMediaAssetMetaData) => {
            onChange(metaData);
            handleClose();
          };
          return <MediaLibraryComponent onChooseAsset={onChooseAsset} />;
        }}
      />
    </FormSubmitBubblingStopper>
  );
};
